module.exports = __webpack_public_path__ + "assets/img/pine grove 84m.fb1efc79.jpg";